export class DataCatalogJoinabilitySide {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "datasetId",
            "baseName": "datasetId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "datasetName",
            "baseName": "datasetName",
            "type": "string",
            "format": ""
        },
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogJoinabilitySide.attributeTypeMap;
    }
    constructor() {
    }
}
